import LinkCardSpec from 'componentSpecs/linkcard.json'
import { useState } from 'react'

import { IPktLinkCard } from '@/components/linkcard/LinkCard'
import ILinkCardSpec from '@/interfaces/ILinkCardSpec'

import { PktLinkCard } from '..'

export default function LinkCard() {
  const linkcardSpec = LinkCardSpec as unknown as ILinkCardSpec
  const [specProps] = useState(linkcardSpec.props)
  return (
    <main className="page-main pkt-container">
      <h1>Linkcard</h1>
      {specProps.skin.type.map((skinType: IPktLinkCard['skin'], index: number) => (
        <section className="component" key={`skin-${index}`}>
          <h2>Skin: {skinType}</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
            <PktLinkCard
              title={skinType}
              key={`skin-${index}-${skinType}-1`}
              iconName="lecture-workplace"
              skin={skinType}
            >
              Skriv en informerende tekst om ønskelig tema her. Legg til knapper eller bilder om du ønsker
            </PktLinkCard>
            <PktLinkCard
              title={skinType}
              key={`skin-${index}-${skinType}-2`}
              iconName="lecture-workplace"
              skin={skinType}
            ></PktLinkCard>
            <PktLinkCard title={skinType} key={`skin-${index}-${skinType}-3`} skin={skinType} iconName="tickets">
              Skriv en informerende tekst om ønskelig tema her. Legg til knapper eller bilder om du ønsker
            </PktLinkCard>
            <PktLinkCard
              title={skinType}
              key={`skin-${index}-${skinType}-4`}
              iconName="cafe"
              skin={skinType}
            ></PktLinkCard>
            <PktLinkCard key={`skin-${index}-${skinType}-5`} skin={skinType}>
              Skriv en informerende tekst om ønskelig tema her. Legg til knapper eller bilder om du ønsker
            </PktLinkCard>
          </div>
        </section>
      ))}
      <section className="component">
        <PktLinkCard
          title="Åpne link i ny fane"
          key="openInNewTab"
          href="https://www.example.com"
          openInNewTab
          external
        >
          Skriv en informerende tekst om ønskelig tema her. Legg til knapper eller bilder om du ønsker
        </PktLinkCard>
      </section>
    </main>
  )
}
